const TOKEN_KEY = 'automates_token'
const USER_KEY = 'automates_user'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getCachedUser() {
  const raw = localStorage.getItem(USER_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setCachedUser(user: { id: string; email: string; name?: string; role?: string; approved?: boolean }): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function isAdmin(): boolean {
  const user = getCachedUser()
  return user?.role === 'admin'
}

export function isApproved(): boolean {
  const user = getCachedUser()
  return !!user?.approved
}

export function isLoggedIn(): boolean {
  return !!getToken()
}
